import React from 'react';
import { Card, Typography, Tag, Space } from 'antd';
import { useTranslation } from 'react-i18next';

const { Title, Paragraph } = Typography;

const About: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="max-w-4xl mx-auto">
      <Title level={2} className="!mb-6">
        {t('nav.about')}
      </Title>

      <Card className="!mb-6">
        <Title level={3}>项目介绍</Title>
        <Paragraph>INTELLiX 项目模板</Paragraph>

        <Title level={4}>主要特性</Title>
        <ul className="list-disc list-inside space-y-2 text-gray-700">
          <li>🚀 基于 React 18.3.1 和 TypeScript </li>
          <li>🎨 Tailwind CSS + Ant Design 5.x </li>
          <li>🌍 集成国际化（i18n）解决方案</li>
          <li>📦 pnpm workspace monorepo 架构</li>
          <li>🔄 Zustand 状态管理 + TanStack Query 数据获取</li>
          <li>🛣️ React Router 路由管理</li>
          <li>⚡ Vite 构建工具</li>
          <li>🔧 开发工具链（ESLint、Prettier、TypeScript）</li>
        </ul>
      </Card>

      <Card className="!mb-6">
        <Title level={3}>技术栈详情</Title>

        <div className="space-y-4">
          <div>
            <Title level={5}>核心框架</Title>
            <Space wrap>
              <Tag color="blue">React 18.3.1</Tag>
              <Tag color="blue">TypeScript</Tag>
              <Tag color="blue">Vite</Tag>
            </Space>
          </div>

          <div>
            <Title level={5}>UI 框架</Title>
            <Space wrap>
              <Tag color="green">Tailwind CSS</Tag>
              <Tag color="green">Ant Design 5.x</Tag>
            </Space>
          </div>

          <div>
            <Title level={5}>状态管理</Title>
            <Space wrap>
              <Tag color="purple">Zustand</Tag>
              <Tag color="purple">TanStack Query</Tag>
            </Space>
          </div>

          <div>
            <Title level={5}>路由 & 国际化</Title>
            <Space wrap>
              <Tag color="orange">React Router</Tag>
              <Tag color="orange">react-i18next</Tag>
            </Space>
          </div>

          <div>
            <Title level={5}>开发工具</Title>
            <Space wrap>
              <Tag color="red">ESLint</Tag>
              <Tag color="red">Prettier</Tag>
              <Tag color="red">pnpm</Tag>
            </Space>
          </div>
        </div>
      </Card>

      <Card>
        <Title level={3}>项目结构</Title>
        <Paragraph>
          <pre className="bg-gray-50 p-4 rounded text-sm overflow-x-auto">
            {`IntelliXWeb/
├── apps/                    # 应用目录
│   └── template-app/        # 模板应用
│       ├── src/
│       │   ├── components/  # 组件
│       │   ├── pages/       # 页面
│       │   ├── hooks/       # 自定义 hooks
│       │   ├── store/       # 状态管理
│       │   ├── i18n/        # 国际化
│       │   ├── types/       # 类型定义
│       │   └── utils/       # 工具函数
│       ├── package.json
│       └── vite.config.ts
├── packages/                # 共享包目录
│   └── api-client/          # API 客户端
├── package.json             # 根 package.json
├── pnpm-workspace.yaml      # pnpm workspace 配置
└── tsconfig.json            # TypeScript 配置`}
          </pre>
        </Paragraph>
      </Card>
    </div>
  );
};

export default About;
